import React, { FC, Fragment, useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { EbrProfilesCount } from 'api';

import { common, COLORS } from '../styles';

interface Props {
  data: EbrProfilesCount[];
}

const MIN_PIXEL_WIDTH = 36;

const styles = {
  bar: {
    backgroundColor: COLORS.blue3,
    height: 20,
    borderRadius: 12,
  },
  barLabel: {
    ...common.paragraph2,
    marginLeft: 1,
  },
};

const AdvocacyBars: FC<Props> = ({ data }) => {
  const sortedData = data.sort((a, b) => b.percentage - a.percentage);
  const maxPercentage = Math.max(...data.map(item => item.percentage));

  const containerRef = useRef(null);
  const [barWidths, setBarWidths] = useState([]);

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const containerWidth = containerRef.current.getBoundingClientRect().width || 0;
    const updatedWidths = data.map(item => {
      const proposedBarWidth = (item.percentage / maxPercentage) * containerWidth;
      return proposedBarWidth < MIN_PIXEL_WIDTH ? MIN_PIXEL_WIDTH : proposedBarWidth;
    });

    setBarWidths(updatedWidths);
  }, [containerRef.current]);

  function applyContainerRef(ref: unknown, index: number) {
    if (index === 0) {
      containerRef.current = ref;
    }
  }

  function renderBar(item: EbrProfilesCount, index: number) {
    const width = barWidths.length ? barWidths[index] : '100%';

    return (
      <Box marginBottom={2} display="flex" alignItems="center" key={index}>
        <Box
          ref={el => applyContainerRef(el, index)}
          display="flex"
          alignItems="center"
          sx={{ ...styles.bar, width }}
        >
          <Typography sx={styles.barLabel}>{`${item.percentage}%`}</Typography>
        </Box>
        <Typography title={item.name} noWrap sx={{ ...styles.barLabel, flexShrink: 0 }}>
          {item.name}
        </Typography>
      </Box>
    );
  }

  return <Fragment>{sortedData.map(renderBar)}</Fragment>;
};

export default AdvocacyBars;
